import axios from 'axios';
import config from '../config';
import { OnboardDeviceHardwareConfiguration } from '../interfaces';

export const getOnboardDevicesHardwareConfigurations = (): Promise<OnboardDeviceHardwareConfiguration[]> => {
    return axios.get(`${config.API_URL}/onboard-devices/hardware-configurations`).then((response: any) => {
        return response.data;
    });
};
